import _ from 'lodash';
import * as types from '../constants/ActionTypes';

const initialState = {
	item: null,
	list: [],
	counts: null,
	pagination: null,
	isFetchingItem: false,
	isSavingItem: false,
	isFetchingList: false,
	isFetchingCounts: false,
	error: null,
};

export default function lots (state = initialState, action) {
	switch (action.type) {
		case types.REQUEST_LOT_LIST:
			return {
				...state,
				isFetchingList: true,
				error: null
			};

		case types.RECEIVE_LOT_LIST:
			return {
				...state,
				list: action.response.results,
				pagination: action.response.pagination,
				isFetchingList: false,
			};

		case types.REQUEST_LOT:
			return {
				...state,
				item: null,
				isFetchingItem: true,
				error: null
			};

		case types.RECEIVE_LOT:
			return {
				...state,
				item: action.response.lot,
				isFetchingItem: false,
			};

		case types.SUBMIT_EDIT_LOT:
			return {
				...state,
				isSavingItem: true,
			};

		case types.RESOLVE_EDIT_LOT:

			let newState = { ...state, isSavingItem: false };

			// Copy the lots list while updating the data for the edited one
			newState.list = state.list.map(lot => {

				// If the lot matches the updated one then
				// update the lot's override data
				if (lot.id == action.id) {
					lot.override = _.assign({}, lot.override, action.data);
				}

				return lot;
			});

			return newState;

		case types.RECEIVE_EDIT_LOT_ERROR:
			return {
				...state,
				isSavingItem: false,
				error: action.error,
			};

		case types.REQUEST_LOT_COUNTS:
			return {
				...state,
				counts: null,
				isFetchingCounts: true,
				error: null
			};

		case types.RECEIVE_LOT_COUNTS:

			let counts = {
				total: action.response.headers['x-total'],
			};

			if (action.response.headers['x-empty-lots']) {
				counts['empty'] = action.response.headers['x-empty-lots'];
			}
			if (action.response.headers['x-plan-lots']) {
				counts['plan'] = action.response.headers['x-plan-lots'];
			}
			if (action.response.headers['x-spec-lots']) {
				counts['spec'] = action.response.headers['x-spec-lots'];
			}

			return {
				...state,
				counts,
				isFetchingCounts: false,
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/reducers/lots.js